import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/attendance-management-system/shift-management/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "shift-management" entry is kept); the seo block below is a fallback.

export const shiftManagement: ContentPage = {
  slug: "attendance-management-system/shift-management",
  template: "hrmsFeature",
  seo: {
    title: "Advanced Shift Management for Optimal Staffing",
    description: "Boost efficiency with automated shift scheduling, real-time updates, and easy shift swaps in our comprehensive shift management system.",
    keywords: [
      "shift management",
      "automated scheduling",
      "shift swap",
      "shift planning software",
      "workforce scheduling.",
    ],
    ogImage: "/assets/data/seoimages/shift-management.webp",
  },
  leaf: {
    hero: {
      caption: "Shift Management",
      title: "Optimize Shift Scheduling and Management",
      description: "Manage and automate employee shifts efficiently to ensure coverage and reduce scheduling conflicts with our advanced shift management tools.",
      h1: "caption",
    },
    split: {
      title: "Streamline Your Shift Operations",
      bullets: [
        { title: "Automated Scheduling", description: "Create and assign shifts based on availability and skills." },
        { title: "Shift Swap Functionality", description: "Facilitate easy shift trades with managerial approval workflows." },
        { title: "Real-Time Notifications", description: "Send instant updates about shift changes or assignments." },
        { title: "Shift Analytics", description: "Monitor and analyze shift patterns and employee performance." },
      ],
      image: "/assets/images/img/product/hrms/attendancems/shift-management.webp",
      imageAlt: "shift-management",
    },
    cardsHeading: {
      title: "Key Features of Attendance Management System",
      description: "Optimize Attendance management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Absence Management",
        href: "/hrms-software/attendance-management-system/absence-management",
        description: "Efficiently manage and track employee absences and leaves with our comprehensive absence management system, reducing disruptions and ensuring compliance.",
        image: "/assets/images/img/product/hrms/attendancems/absence-management_key_features.webp",
        imageAlt: "absence-management_key_features",
      },
      {
        title: "Real-Time Attendance Tracking",
        href: "/hrms-software/attendance-management-system/real-time-attendance-tracking",
        description: "Capture accurate employee attendance data in real-time, streamlining payroll processes and enhancing workforce management.",
        image: "/assets/images/img/product/hrms/attendancems/real_time-attendance_tracking_key_features.webp",
        imageAlt: "real_time-attendance_tracking_key_features",
      },
      {
        title: "Overtime Monitoring",
        href: "/hrms-software/attendance-management-system/overtime-monitoring",
        description: "Ensure fair compensation and compliance with our sophisticated overtime monitoring system, reducing discrepancies and boosting morale.",
        image: "/assets/images/img/product/hrms/attendancems/overtime-monitoring_key_features.webp",
        imageAlt: "overtime-monitoring_key_features",
      },
      {
        title: "Geofencing Attendance",
        href: "/hrms-software/attendance-management-system/geofencing-attendance",
        description: "Utilize geofencing technology to manage employee attendance more securely and accurately, ideal for remote or on-site tracking.",
        image: "/assets/images/img/product/hrms/attendancems/geofencing_attendance_key_features.webp",
        imageAlt: "geofencing_attendance_key_features",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Transform Your Shift Management Today!",
    relatedBlogs: "static",
    metaKey: "shift-management",
  },
  sections: [],
};
